<div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header d-flex align-items-center">
          <span class="mr-auto">
            <i class="fa fa-users"></i> Lista de Partners
          </span>
          <span class="ml-auto">
            <button class="btn btn-primary action-btn" (click)="add()">
              <i class="fa fa-plus-square"></i>
              Agregar Partner
            </button>
          </span>
        </div>
        <div class="card-body">
          <app-datatable [options]="dtConfig"></app-datatable>
        </div>
      </div>
    </div>
  </div>
  